import { Dispatch } from "react";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { UserAddressService } from "Bands/services";
import { USER_ACTIONS } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IPlace, IDataKeys } from "shared/types";
import { IStoreState } from "App/types";

export const dispatchGetUserAddresses = (dispatch: Dispatch<any>, userId?: string) => {
  dispatch(
    getUserAddresses({
      userId,
      page: 1,
      paginationKey: USER_ACTIONS.getUserAddresses,
    })
  );
};

const getUserAddresses = createAsyncThunk(
  USER_ACTIONS.getUserAddresses,
  async (
    { userId }: { userId?: string; page: number; paginationKey: string },
    { rejectWithValue, getState }
  ) => {
    try {
      const { currentUser } = (getState() as IStoreState).auth;

      const data = await UserAddressService.getUserAddresses({
        user: API_ENDPOINTS.USER(userId || currentUser?.id || ""),
      });

      return {
        [IDataKeys.userAddress]: data.userAddress,
        meta: data.meta,
        pagination: data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createUserAddress = createAsyncThunk(
  USER_ACTIONS.createUserAddress,
  async (address: IPlace, { rejectWithValue }) => {
    try {
      const data = await UserAddressService.createUserAddress(address);
      const id = Object.values(data?.userAddress)?.[0]?.attributes?.id;

      return { id, data };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editUserAddress = createAsyncThunk(
  USER_ACTIONS.editUserAddress,
  async ({ id, data }: { id: string; data: Partial<IPlace> }, { rejectWithValue }) => {
    try {
      const editedAddress = await UserAddressService.editUserAddress(id, data);

      return editedAddress;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteUserAddress = createAsyncThunk(
  USER_ACTIONS.deleteUserAddress,
  async (id: string, { rejectWithValue }) => {
    try {
      await UserAddressService.deleteUserAddress(id);

      return {
        path: API_ENDPOINTS.USER_ADDRESS(id),
        dataKey: IDataKeys.userAddress,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
